<template>
  <div>
    <section class="box" v-if="datas">
      
      <!-- 企业主页 -->
      <div class="box-main" v-show="menu.index == 0">

        <nav class="tablebar" style="top: 0;position: sticky;">
          <div class="line" :style="{width: `calc(50% - 20px)`, left: `calc(${tabs.index * 50}% + 5px)`}"></div>
          <div class="menu">
            <ul class="row" :class="{topac: index == tabs.index}" v-for="(item, index) in tabs.list" :key="index" @click="tabs.index = index">
              <li><span class="iconfont" :class="item.icon"></span></li>
              <li class="name">{{ item.name }}</li>
            </ul>
          </div>
        </nav>
        
        <!-- 企业首页 -->
        <div v-show="tabs.index == 0">
          <div class="content" v-if="datas.business && datas.business_is_show == 1">
            <div class="voice" @click="playClick('businessRef')">(语音播报<span class="iconfont icon-laba"></span>)</div>

            <div class="title-nav">
              <span class="icon">01</span>
              <span class="tit">基本信息</span>
            </div>

            <ul class="form__main form__main_one" ref="businessRef">
              <li class="row">
                <p class="lable">企业名称</p>
                <p class="value">{{datas.business.name}}</p>
              </li>
              <li class="row" v-if="datas.business.baddress">
                <p class="lable">企业地址</p>
                <p class="value">{{datas.business.baddress}}</p>
              </li>
              <li class="row" v-if="datas.business.linkphone">
                <p class="lable">联系电话</p>
                <p class="value">{{datas.business.linkphone}}</p>
              </li>
              <li class="row" v-if="datas.business.organization_code">
                <p class="lable">统一社会信用代码</p>
                <p class="value">{{datas.business.organization_code}}</p>
              </li>
            </ul>
          </div>

          <div class="content">
            <div class="title-nav">
              <span class="icon">02</span>
              <span class="tit">资质证书</span>
            </div>

            <viewer @inited="inited" ref="viewer">
              <div class="img-list">
                <p class="img-box" v-if="datas.business.blicense"><img :src="datas.business.blicense" /></p>
                <template v-for="(item, index) in datas.business.customize_data">
                  <p class="img-box" v-if="item.value && item.value.includes('http')" :key="index">
                    <img :src="item.value">
                  </p>
                </template>
              </div>
            </viewer>
          </div>
        </div>

        <!-- 阳光工厂 -->
        <div class="content" v-show="tabs.index == 1">
          <div class="title-nav">
            <span class="icon iconfont icon-shiligongchang"></span>
            <span class="tit">阳光工厂</span>
          </div>

          <div class="video-box" v-if="datas.video && datas.video_is_show == 1">
            <video :src="datas.video.url" controls id="VideoBox" class="VideoBox" :poster="datas.video.url + '?vframe/jpg/offset/1/w/400/'">
            </video>
          </div>
        </div>

      </div>

      <!-- 追溯产品 -->
      <div v-show="menu.index == 1">
        <img class="head" :src="`/static/images/Normal27/banner${datas.product.product_sz_code?'-':''}.png`" />

        <!-- 焦点图 -->
        <div class="swiper-container banner" v-if="datas.focus && datas.focus_pics_is_show == 1">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in datas.focus" v-bind:key="index"><img :src="item.img"></div>
          </div>
          <div class="swiper-pagination"></div> 
        </div>

        <div class="bg-white">
          <div class="tips">
            <div class="tips__main">
              <span class="iconfont icon-tishi"></span>
              <span>本追溯信息由该产品的生产企业授权本系统提供</span>
            </div>
          </div>

          <div class="product-name">
            <span class="iconfont icon-chanpinku"></span>
            <span class="lable">产品名称:</span>
            <span class="value">{{datas.product.name}}</span>
          </div>
        </div>

        <div class="form" v-if="datas.product && datas.prod_is_show == 1">
          <div class="titbar">
            <img class="img" src="/static/images/Normal27/titbar.png" />
            <div class="tit">数字标签</div>
          </div>

          <div class="voice" @click="playClick('productRef')">(语音播报<span class="iconfont icon-laba"></span>)</div>

          <ul class="form__main form__main_two" ref="productRef">
            <li class="row" v-if="datas.product.productTypeName">
              <p class="lable">产品类型</p>
              <p class="value">{{datas.product.productTypeName}}</p>
            </li>
            <li class="row">
              <p class="lable">产品名称</p>
              <p class="value">{{datas.product.name}}</p>
            </li>
            <li class="row" v-if="datas.product.unit && datas.prod_unit_is_show">
              <p class="lable">规格单位</p>
              <p class="value">{{datas.product.unit}}</p>
            </li>
            <li class="row" v-if="datas.product.standards">
              <p class="lable">商品条码</p>
              <p class="value"><svg ref="barcodeSvg"></svg></p>
            </li>
            <li class="row" v-if="datas.product.period && datas.prod_period_is_show">
              <p class="lable">保质期</p>
              <p class="value">{{datas.product.period}}</p>
            </li>
            <li class="row" v-if="datas.product.model">
              <p class="lable">型号</p>
              <p class="value">{{datas.product.model}}</p>
            </li>
            <li class="row" v-for="(item, index) in datas.product.attribute" :key="index">
              <p class="lable">{{ item.key }}</p>
              <p class="value">{{ item.value }}</p>
            </li>
          </ul>
        </div>

        <div class="form" v-if="datas.source">
          <div class="titbar">
            <img class="img" src="/static/images/Normal27/titbar.png" />
            <div class="tit">出厂流向信息</div>
          </div>

          <ul class="form__main form__main_two">
            <li class="row">
              <p class="lable">供应商</p>
              <p class="value">{{datas.source.supplier_name}}</p>
            </li>
            <li class="row" v-if="datas.source.material_name">
              <p class="lable">物料名称</p>
              <p class="value">{{datas.source.material_name}}</p>
            </li>
            <li class="row" v-if="datas.source.stock_date">
              <p class="lable">进货日期</p>
              <p class="value">{{datas.source.stock_date}}</p>
            </li>
            <li class="row" v-if="datas.source.stock_batch_no">
              <p class="lable">进货批次</p>
              <p class="value">{{datas.source.stock_batch_no}}</p>
            </li>
          </ul>
        </div>

        <div class="form" v-if="datas.source">
          <div class="titbar">
            <img class="img" src="/static/images/Normal27/titbar.png" />
            <div class="tit">销售流向信息</div>
          </div>

          <ul class="form__main form__main_two">
            <li class="row" v-if="datas.source.distributor_visible === 1">
              <p class="lable">经销商</p>
              <p class="value">{{datas.source.distributor}}</p>
            </li>
            <li class="row" v-if="datas.source.customer && datas.source.customer_visible === 1">
              <p class="lable">购方客户</p>
              <p class="value">{{datas.source.customer}}</p>
            </li>
            <li class="row" v-if="datas.source.sale_time && datas.source.sale_time_visible === 1">
              <p class="lable">销售日期</p>
              <p class="value">{{datas.source.sale_time}}</p>
            </li>
            <li class="row" v-if="datas.source.recipient_contact && datas.source.recipient_contact_visible === 1">
              <p class="lable">联系方式</p>
              <p class="value">{{datas.source.recipient_contact}}</p>
            </li>
            <li class="row" v-if="datas.source.recipient_addr && datas.source.recipient_addr_visible === 1">
              <p class="lable">客户地址</p>
              <p class="value">{{datas.source.recipient_addr}}</p>
            </li>
            <li class="row" v-if="datas.source.sell_order_no">
              <p class="lable">销售订单号</p>
              <p class="value">{{datas.source.sell_order_no}}</p>
            </li>
          </ul>
        </div>

        <!-- 经销商流程 -->
        <div class="form" v-if="datas.dealer && datas.dealer_is_show == 1">
          <div class="titbar">
            <img class="img" src="/static/images/Normal27/titbar.png" />
            <div class="tit">经销商流程</div>
          </div>

          <div class="MainDatasBox">
            <ul class="MainData TraceData" v-for="(item, index) in datas.dealer" :key="index">
              <i class="TraceDataDotBox"><i class="TraceDataDot"></i></i>
              <i class="TraceDataDotBox TraceDataDotBottomBox" v-if="index == datas.dealer.length - 1"><i class="TraceDataDot"></i></i>
              <i class="TraceDataLine"></i>
              <li class="MainContent">
                <div class="MainDataLeft">
                  <p v-text="item.name"></p>
                  <p class="MainDataHint" v-text="item.date.substring(0, 10)"></p>
                </div>
                <div class="MainDataRight MainDataRightImg backImg" :style="{ backgroundImage: 'url(' + item.icon + ')' }">
                  <img class="OpacityImg" :src="item.icon"></div>
              </li>
            </ul>
          </div>
        </div>

      </div>
      
      <!-- 科普知识 -->
      <div v-show="menu.index == 2">
        
        <div class="searchbar">
          <input class="search" v-model="searchText" placeholder="请输入要搜索的关键词" />
          <span class="btn iconfont icon-sousuo"></span>
        </div>

        <div class="card-box" v-if="datas.menu && datas.menu_is_show == 1">
          <template v-for="(item, index) in datas.menu">
            <ul class="row" v-show="item.name.includes(searchText)" :key="index" @click="menuClick(item)">
              <li class="img"><img :src="item.icon" /></li>
              <li class="main">
                <p class="tit">{{item.name}}</p>
                <p class="date">{{item.describe}}</p>
              </li>
            </ul>
          </template>
        </div>

      </div>

      <!-- 底部菜单 -->
      <nav class="tablebar" style="bottom: 0;">
        <div class="line" :style="{width: `calc(33.33% - 20px)`, left: `calc(${menu.index * 33.33}% + 10px)`}"></div>
        <div class="menu">
            <ul class="row" style="padding-bottom: 15px;" v-for="(item, index) in menu.list" :class="{ac: index == menu.index}" :key="index" @click="menu.index = index">
              <li><span class="iconfont" :class="item.icon"></span></li>
              <li class="name">{{ item.name }}</li>
            </ul>
        </div>
      </nav>

    </section>

    <!-- 创建一个隐藏的audio元素 -->
    <audio id="audioPlayer" style="display: none;"></audio>
    
    <K-AlertMsg :AlertMsg="AlertMsg" bg="#8bbd21" @AlertBack="AlertBack"></K-AlertMsg>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Swiper from 'swiper'
import JsBarcode from 'jsbarcode';
import Speaker from '../hook/auto.js'
import mixin from '../mixins/mixin.js'
import { formatDate } from '@/hook/common.js'
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
export default {
  name: 'Normal27',
  mixins: [mixin],
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      audioSrc: '',
      isCheck: false,
      searchText: '',
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      menu: {
        index: 1,
        list: [{
          icon: 'icon-zhuye',
          name:'企业主页', 
        },{
          icon: 'icon-shangpinzhuisu',
          name:'追溯产品', 
        },{
          icon: 'icon-kepuzhishi',
          name:'科普知识'
        }]
      },
      tabs: {
        index: 0,
        list: [{
          icon: 'icon-shiligongchang',
          name:'企业首页', 
        },{
          icon: 'icon-gongchang',
          name:'阳光工厂', 
        }]
      }
    }
  },
  created() {
    self = this;
    this.AdaptiveSizeNew();
    document.body.style.backgroundColor = "#f7f7f7";
    document.title = "防伪查询";  //设置页面标题

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  computed:{
    successMsg(){
      return this.datas.first_antifake_msg || '尊敬的用户，您查询的商品为正品，请放心使用！'
    },
    errorMsg(){
      return this.datas.many_antifake_msg|| '尊敬的用户，您所查询的条码已失效！';
    },
  },
  methods: {
    generateBarcode(code) {
      JsBarcode(this.$refs.barcodeSvg, code, {
        format: 'CODE128', // 条形码类型
        lineColor: '#000', // 线条颜色
        width: 1,         // 单条线宽度
        height: 50,      // 高度
        fontSize: 18,
        margin: 0,
        displayValue: true // 显示文本
      });
    },
    menuClick(item){
      console.log('item', item)
      if(item.url){
        this.skipLink(item.url);
      }
    },
    playClick(key){
      const msg = this.$refs[key].outerText.replace(/\n/g, ',');
      this.playAudio(msg);
    },
    playAudio(msg){
      const audioPlayer = document.getElementById('audioPlayer');
      audioPlayer.src = this.GetServerUrl(1) + `getVoice?text=${msg}`;
      audioPlayer.load();  // 加载音频文件
      audioPlayer.play();  // 播放音频
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.query_count = response.data.meta.query_count;  //查询次数
          datas.query_first_time = response.data.meta.query_first_time;  //查询时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.code = self.code; //二维码
          datas.source = response.data.meta.source;

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;
          self.isCheck = sessionStorage.getItem(`wwm_code_${self.code}`)?true:false;

          setTimeout(() => {
            new Swiper('.banner', {
              autoplay: {
                delay: 5000
              },//可选选项，自动滑动
              loop: true, //可选选项，开启循环
              pagination: {
                el: '.swiper-pagination',
                bulletActiveClass : 'Normal27-banner-active',
              }
            }) 
            
            if(datas.product.standards){
              self.generateBarcode(datas.product.standards);
            }
          });

        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>
<style scoped lang="scss">
$themeColor: #1677ff;
$borderColor: #d9d9d9;
.p10{
  padding: 15px;
}
.p20{
  padding: 25px;
}
.bg-white{
  background-color: white;
}
.box{
  font-size: 16px;
  padding-bottom: 85px;
  .head{
    width: 100%;
    display: block;
  }

  .banner{
    img{
      width: 100%;
      display: block;
    }
  }

  .tips{
    padding: 10px;
    font-size: 15px;
    .tips__main{
      padding: 5px;
      text-align: center;
      border-radius: 5px;
      color: rgb(153, 153, 153);
      background-color: rgb(248, 248, 248);
      .iconfont{
        font-size: 14px;
        color: #f5ac24;
      }
    }
  }

  .product-name{
    padding: 10px;
    font-size: 14px;
    border-bottom: 1px solid #F0F0F0;
    .iconfont{
      width: 20px;
      height: 20px;
      padding: 4px;
      font-size: 13px;
      color: white;
      border-radius: 20px;
      background-color: $themeColor;
    }
    .lable{
      color: rgb(153, 153, 153);
    }
    .value{
      color: rgba(0, 0, 0, 0.88);
    }
  }


  .form{
    padding: 10px;
    margin-top: 5px;
    background-color: white;
    .titbar{
      display: flex;
      justify-content: center;
      align-items: center;
      .img{
        width: 100%;
        display: block;
      }
      .tit{
        color: white;
        font-size: 15px;
        font-weight: bold;
        position: absolute;
      }
    }
  }

  
  .content{
    margin: 8px 5px;
    padding: 5px;
    background-color: white;
  }

  .voice{
    color: $themeColor;
    font-size: 14px;
    display: flex;
    align-items: center;
    .iconfont{
      font-size: 18px;
    }
  }

  .title-nav{
    display: flex;
    padding: 8px 0;
    align-items: center;
    .icon{
      width: 25px;
      height: 25px;
      color: white;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $themeColor;
    }
    .tit{
      font-size: 18px;
      font-weight: bold;
      margin-left: 5px;
      line-height: 1;
    }
  }

  .img-list{
    gap: 5px;
    display: flex;
    flex-wrap: wrap;
    .img-box{
      width: calc(33.33% - 4px);
      height: 24vw;
      overflow: hidden;
    }
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .video-box{
    width: 100%;
    height: 50vw;
    background-color: black;
    .VideoBox{
      width: 100%;
      height: 100%;
    }
  }

  .form__main{
    .row{
      display: flex;
      align-items: center;
      font-size: 14px;
      .lable{
        color: rgb(153, 153, 153);
      }
      .value{
        color: rgba(0, 0, 0, 0.88);
      }
    }
  }
  .form__main_one{
    padding:8px 5px;
    background-color: rgb(247, 247, 247);
    .row{
      &:not(:first-child){
        margin-top: 10px;
      }
      .lable{
        width: 60px;
      }
      .value{
        margin-left: 13px;
        width: calc(100% - 73px);
      }
    }
  }
  .form__main_two{
    .row{
      padding:12px 0;
      align-items: flex-start;
      &:not(:last-child){
        border-bottom: 1px solid #F6F6F6;
      }
      .lable{
        width: 80px;
      }
      .value{
        margin-left: 10px;
        width: calc(100% - 90px);
      }
    }
  }


  .searchbar{
    padding: 10px 10px 0 10px;
    display: flex;
    .search{
      background-color: white;
      height: 40px;
      flex: 1;
      padding: 0 10px;
      font-size: 15px;
      border: 1px solid $borderColor;
      border-right: 0;
      border-radius:  5px 0 0 5px ;
      box-shadow: none;
    }
    input::placeholder {
      color: #aaa;
    }
    .btn{
      width: 40px;
      height: 40px;
      display: flex;
      color: rgba(0, 0, 0, 0.6);
      align-items: center;
      justify-content: center;
      border: 1px solid $borderColor;
      background-color: white;
      border-radius: 0 5px 5px 0;
    }
  }

  .card-box{
    gap: 15px;
    display: flex;
    padding: 10px 20px;
    flex-direction: column;
    .row{
      display: flex;
      padding: 8px 15px;
      border-radius: 10px;
      align-items: center;
      background-color: white;
      border: 1px solid $borderColor;
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
      img{
        width: 40px;
        height: 40px;
        display: block;
      }
      .main{
        padding-left: 10px;
        box-sizing: border-box;
        width: calc(100% - 40px);
        .tit{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          font-weight: bold;
        }
        .date{
          color: rgb(153, 153, 153);
          font-size: 14px;
          text-align: right;
          margin-top: 3px;
        }
      }
    }
  }

  
  //底部菜单
  .tablebar{
    position: fixed;
    left: 0;
    right: 0;
    z-index: 9;
    border-top: 1px solid #F0F0F0;
    background-color: white;

    .line{
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      transition: left 0.3s;
      background-color: $themeColor;
    }
    .menu{
      padding: 0 5px;
      display: flex;
      gap: 20px;
      .row{
        flex: 1;
        text-align: center;
        padding: 10px 0;
        position: relative;
        box-sizing: border-box;
        .iconfont{
          font-size: 25px;
          color: #AAA;
        }
        .name{
          font-size: 14px;
        }
      }
      .ac{
        .iconfont{
          color: $themeColor;
        }
        .name{
          color: $themeColor;
        }
      }
      .topac{
        .iconfont{
          color: black;
        }
        .name{
          color: black;
        }
      }
    }
  }

  /* 溯源信息 */
  .MainDatasBox{
    padding: 0 20px 0 0;
    word-wrap: break-word;
    position: relative;

    .TraceData {
      padding-left: 25px;
      padding-top: 0;
      position: relative;
    }

    .TraceData:first-child {
      margin-top: 15px;
    }

    .TraceDataDotBox {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 11px;
      height: 17px;
      background-color: #FFF;
      z-index: 2;
    }

    .TraceDataDot {
      display: block;
      position: absolute;
      width: 10px;
      height: 10px;
      border: 2px solid #2C5DE8;
      border-radius: 10px;
      z-index: 2;
    }

    .TraceDataDotBottomBox {
      top: auto;
      bottom: 0;
      .TraceDataDot{
      }
    }

    .TraceDataLine {
      display: block;
      position: absolute;
      top: 8px;
      left: 6px;
      bottom: 5px;
      border-left: 2px dashed #2C5DE8;
      z-index: 1;
    }

    .MainContent{
      display: flex;
      gap: 20px;
      align-items: flex-start;
      justify-content: space-between;
      &:not(:first-child){
        margin-top: 10px;
      }

      .MainDataLeft{
        font-size: 14px;
      }

      .MainDataRightImg {
          max-width: 150px;
          min-width: 150px;
          height: 100px;
          overflow: hidden;
      }
    }

    .MainDataHint {
      margin-top: 4px;
      color: #666;
      font-size: 13px;
    }

  }
  

}
</style>



// WEBPACK FOOTER //
// src/view/Normal27.vue